var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11.667C24.5 19.8337 14 26.8337 14 26.8337C14 26.8337 3.5 19.8337 3.5 11.667C3.5 8.88222 4.60625 6.2115 6.57538 4.24237C8.54451 2.27324 11.2152 1.16699 14 1.16699C16.7848 1.16699 19.4555 2.27324 21.4246 4.24237C23.3938 6.2115 24.5 8.88222 24.5 11.667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.167C15.933 15.167 17.5 13.6 17.5 11.667C17.5 9.734 15.933 8.16699 14 8.16699C12.067 8.16699 10.5 9.734 10.5 11.667C10.5 13.6 12.067 15.167 14 15.167Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTracking);
export default __webpack_public_path__ + "static/media/live_tracking.4a98651674a733d8a1d22ff024fbbc93.svg";
export { ForwardRef as ReactComponent };